//#Global Imports
import React from "react";
//#end Global Imports

//#Local Imports
import Button from "../../components/ui/Button";
import Typograpy from "../../components/ui/Typography";
import { toast } from "react-toastify";
import MixpanelConfig from "../../constants/MixpanelConfig";
//#end Local Imports

type RecipientDetailsProps = {
  recipientData: any;
  deleteRecipientHandler: any;
  handleSelectedRecipient: any;
};

const RecipientDetails: React.FC<RecipientDetailsProps> = (props) => {
  const { recipientData, deleteRecipientHandler, handleSelectedRecipient } = props;

  return (
    <div className="bg-[#F0F5FF] p-3">
      <div className={` w-full grid grid-cols-10`}>
        <div className="flex flex-col gap-4 col-span-7">
          <div className="flex items-center gap-1">
            <Typograpy
              tagType="div"
              text="Recipient Address : "
              className="text-sm font-normal text-black"
            />
            <Typograpy
              tagType="div"
              text={`${recipientData?.recipientAddress?.trim() || ""}, ${
                recipientData?.city || ""
              }`}
              className="text-sm font-normal text-black break-words cursor-pointer"
            />
          </div>
          <div className={"flex items-center gap-1"}>
            <Typograpy
              tagType="div"
              text="Bank Name : "
              className="text-sm font-normal text-black"
            />
            <Typograpy
              tagType="div"
              text={recipientData?.bankName}
              className="text-sm font-normal text-black"
            />
          </div>
          <div className={"flex items-center gap-1"}>
            <Typograpy tagType="div" text="IBAN : " className="text-sm font-normal text-black" />
            <Typograpy
              tagType="div"
              text={recipientData?.ibanCode}
              className="text-sm font-normal text-black"
            />
          </div>
          <div className="flex items-center gap-1">
            <Typograpy tagType="div" text="SWIFT : " className="text-sm font-normal text-black" />
            <Typograpy
              tagType="div"
              text={recipientData?.swiftCode}
              className="text-sm font-normal text-black"
            />
          </div>
          <div className="flex items-center gap-1">
            <Typograpy
              tagType="div"
              text="Reference No : "
              className="text-sm font-normal text-black"
            />
            <Typograpy
              tagType="div"
              text={recipientData?.refrence || "N/A"}
              className="text-sm font-normal text-black"
            />
          </div>
        </div>
        <div className="flex flex-col items-start justify-start gap-3 cursor-pointer mx-[5.5rem] col-span-3">
          <Button
            bgColor="bg-[#006EFF]"
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-base",
              fontWeight: "font-semibold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded-md",
            }}
            className="p-1"
            onClickHandler={() => {
              toast.success("Recipient Selected. Navigating to Documents...");
              localStorage.setItem("recipient_type", recipientData?.type);
              setTimeout(() => {
                handleSelectedRecipient();
              }, 1000);
              MixpanelConfig.trackEvent(MixpanelConfig.eventNames.Old_Recipient_Select, {
                selectedRecipient: recipientData,
              });
            }}
          >
            Select Recipient
          </Button>
          <div
            onClick={() => deleteRecipientHandler()}
            className="cursor-pointer hover:scale-105 transition-transform duration-200"
          >
            <p className="text-sm text-red-200 underline">Delete Recipient</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RecipientDetails;
